import axios from 'axios';

class Notice {
    // process.env는 .env.development (개발용), .env.production (운영용) 파일의 설정값을 이용한다.
    static _API_URL = process.env.VUE_APP_BIZMSG_API_URL;
    static _API_ENABLE = process.env.VUE_APP_BIZMSG_ENABLE === 'true';
    static _USER_ID = 'atensystem';
    static _PROFILE = 'bd014755667abeee5c87c9212d7e9409163d6df3';
    static _MESSAGE_TYPE = 'AT';
    static _TEMPLATE_1 = 'isens_visit_v1'; // 승인 완료 알림
    static _TEMPLATE_2 = 'isens_visit_v2'; // 방문 신청 알림
    static _TEMPLATE_3 = 'isens_visit_v3_2'; // 반려 알림
    static _TEMPLATE_4 = 'isens_visit_v4'; // 방문객 도착 알림
    static _TEMPLATE_5 = 'isens_visit_v5_2'; // 취소 알림
    static _CONFIG = {
        headers: { 'userId': Notice._USER_ID }
    };
    static _KOREA_INTERNATIONAL_CALLING_CODE = '82';
    static _smsKind = 'L';
    static _smsSender = '028623360';

    _normalizePhoneNumber(number) {
        if (typeof number === 'string' && !number.startsWith(Notice._KOREA_INTERNATIONAL_CALLING_CODE)) {
            return Notice._KOREA_INTERNATIONAL_CALLING_CODE + number.replace(/(^0+)/, "").replaceAll("-", "");
        } else {
            return number;
        }
    }

    async applySendSms(senderPhone, recipientPhone, body, buttonUrl) {
        if (!Notice._API_ENABLE) {
            console.log('bizmsg disabled')
            return;
        }

        try {
            const bizMsgArray = [];
            const bizMsgInfo = {
                message_type: Notice._MESSAGE_TYPE,
                phn: this._normalizePhoneNumber(recipientPhone),
                profile: Notice._PROFILE,
                tmplId: Notice._TEMPLATE_2,
                msg: body,
                button1: {"name": "방문 승인", "type": "WL", "url_pc": buttonUrl, "url_mobile": buttonUrl},
                smsKind: Notice._smsKind,
                msgSms: body + '\n' + buttonUrl,
                smsSender: this._normalizePhoneNumber(senderPhone)
            };
            bizMsgArray.push(bizMsgInfo);

            const response = await axios.post(Notice._API_URL, bizMsgArray, Notice._CONFIG);

            if (response.data[0]?.code === 'fail') {
                console.error('발송 실패 message : ' + response.data[0]?.message);
                console.error('발송 실패 originMessage : ' + response.data[0]?.originMessage);
            }
        } catch (err) {
            console.error(`${recipientPhone} 번호로 알림톡을 발송하지 못했습니다.<br/>${err}`);
        }
    }

    async confirmSendSms(senderPhone, recipientPhone, body, buttonUrl) {
        if (!Notice._API_ENABLE) {
            console.log('bizmsg disabled')
            return;
        }

        try {
            const bizMsgArray = [];
            const bizMsgInfo = {
                message_type: Notice._MESSAGE_TYPE,
                phn: this._normalizePhoneNumber(recipientPhone),
                profile: Notice._PROFILE,
                tmplId: Notice._TEMPLATE_1,
                msg: body,
                button1: {"name": "승인 QR 코드", "type": "WL", "url_pc": buttonUrl, "url_mobile": buttonUrl},
                smsKind: Notice._smsKind,
                msgSms: body + '\n' + buttonUrl,
                smsSender: this._normalizePhoneNumber(senderPhone)
            };
            bizMsgArray.push(bizMsgInfo);

            const response = await axios.post(Notice._API_URL, bizMsgArray, Notice._CONFIG);

            if (response.data[0]?.code === 'fail') {
                console.error('발송 실패 message : ' + response.data[0]?.message);
                console.error('발송 실패 originMessage : ' + response.data[0]?.originMessage);
            }
        } catch (err) {
            console.error(`${recipientPhone} 번호로 알림톡을 발송하지 못했습니다.<br/>${err}`);
        }
    }

    async arrivalSendSms(senderPhone, recipientPhone, body, buttonUrl) {
        if (!Notice._API_ENABLE) {
            console.log('bizmsg disabled')
            return;
        }

        try {
            const bizMsgArray = [];
            const bizMsgInfo = {
                message_type: Notice._MESSAGE_TYPE,
                phn: this._normalizePhoneNumber(recipientPhone),
                profile: Notice._PROFILE,
                tmplId: Notice._TEMPLATE_4,
                msg: body,
                button1: {"name": "예약내용 확인", "type": "WL", "url_pc": buttonUrl, "url_mobile": buttonUrl},
                smsKind: Notice._smsKind,
                msgSms: body + '\n' + buttonUrl,
                smsSender: Notice._smsSender
            };
            bizMsgArray.push(bizMsgInfo);

            const response = await axios.post(Notice._API_URL, bizMsgArray, Notice._CONFIG);

            if (response.data[0]?.code === 'fail') {
                console.error('발송 실패 message : ' + response.data[0]?.message);
                console.error('발송 실패 originMessage : ' + response.data[0]?.originMessage);
            }
        } catch (err) {
            console.error(`${recipientPhone} 번호로 알림톡을 발송하지 못했습니다.<br/>${err}`);
        }
    }

    async rejectSendSms(senderPhone, recipientPhone, body) {
        if (!Notice._API_ENABLE) {
            console.log('bizmsg disabled')
            return;
        }

        try {
            const bizMsgArray = [];
            const bizMsgInfo = {
                message_type: Notice._MESSAGE_TYPE,
                phn: this._normalizePhoneNumber(recipientPhone),
                profile: Notice._PROFILE,
                tmplId: Notice._TEMPLATE_3,
                msg: body,
                smsKind: Notice._smsKind,
                msgSms: body,
                smsSender: this._normalizePhoneNumber(senderPhone)
            };
            bizMsgArray.push(bizMsgInfo);

            const response = await axios.post(Notice._API_URL, bizMsgArray, Notice._CONFIG);

            if (response.data[0]?.code === 'fail') {
                console.error('발송 실패 message : ' + response.data[0]?.message);
                console.error('발송 실패 originMessage : ' + response.data[0]?.originMessage);
            }
        } catch (err) {
            console.error(`${recipientPhone} 번호로 알림톡을 발송하지 못했습니다.<br/>${err}`);
        }
    }
    async cancelSendSms(senderPhone, recipientPhone, body) {
        if (!Notice._API_ENABLE) {
            console.log('bizmsg disabled')
            return;
        }

        try {
            const bizMsgArray = [];
            const bizMsgInfo = {
                message_type: Notice._MESSAGE_TYPE,
                phn: this._normalizePhoneNumber(recipientPhone),
                profile: Notice._PROFILE,
                tmplId: Notice._TEMPLATE_5,
                msg: body,
                smsKind: Notice._smsKind,
                msgSms: body,
                smsSender: this._normalizePhoneNumber(senderPhone)
            };
            bizMsgArray.push(bizMsgInfo);

            const response = await axios.post(Notice._API_URL, bizMsgArray, Notice._CONFIG);

            if (response.data[0]?.code === 'fail') {
                console.error('발송 실패 message : ' + response.data[0]?.message);
                console.error('발송 실패 originMessage : ' + response.data[0]?.originMessage);
            }
        } catch (err) {
            console.error(`${recipientPhone} 번호로 알림톡을 발송하지 못했습니다.<br/>${err}`);
        }
    }

}

export default new Notice();